export default "__VITE_ASSET__ydmc7e5Q__"